<script>
export default {
  data() {
    return {
      serverErrors: []
    }
  },
  computed: {
    showResourceErrors() {
      let show = this.resourceErrors.length > 0
      return show
    },
    resourceErrors() {
      const errors = []
      // if (this.$v.form && !this.$v.form.$dirty) return errors
      this.getServerErrors('resource', errors)
      return errors
    }
  },
  methods: {
    // TODO: rename to `addServerErrors` since this is not a getter
    getServerErrors(name, errors) {
      const nameError = this.serverErrors.find((field) => field.name === name)
      if (nameError) {
        for (var error of nameError.messages) {
          errors.push(error)
        }
      }
    },
    setServerErrors(data) {
      const { errors } = data
      this.serverErrors = errors
    },
    resetServerErrors() {
      this.serverErrors = []
    }
  }
}
</script>
